import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, switchMap, first } from 'rxjs/operators';
import { OnboardingFacade } from 'app/main/pages/customer-onboard-flow/store/onboarding/onboarding.facade';
import { GlobalService } from 'app/global/global.service';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root'
})
export class OnboardingGuard implements CanActivate {
  constructor(
    private onboardingFacade: OnboardingFacade,
    private router: Router,
    private globalService: GlobalService,
    private translocoService: TranslocoService
  ) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const token = route.paramMap.get('token');

    if (!token) {
      this.globalService.toastrError(this.translocoService.translate('onboarding bad url error message (onboarding guard) - Onboarding link is invalid or missing a token.'));
      return of(this.router.createUrlTree(['/login']));
    }

    // Dispatch the action to check the token
    this.onboardingFacade.checkToken(token);

    // Listen for the result from the store
    return this.onboardingFacade.loading$.pipe(
      first(loading => loading === false), // Wait until the loading state is false
      switchMap(() => this.onboardingFacade.error$), // Then get the latest error state
      map(error => {
        if (error) {
          if (error === 'invalid_token') {
            this.globalService.toastrError(this.translocoService.translate('onboarding bad token error message (onboarding guard) - Onboarding already completed or the link is invalid'));
          } else {
            this.globalService.toastrError(error);
          }
          return this.router.createUrlTree(['/login']);
        }
        return true; // If there's no error, allow activation
      })
    );
  }
}
